<template>
  <div id="app">
    <sidebar />
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'eternalmon'
  }
</script>

<style>
#app {
}
</style>



// WEBPACK FOOTER //
// src/App.vue